import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/PageHeader";
import { SettingsMenu } from "@/settings/SettingsMenu";

export const Route = createFileRoute("/(authed)/_layout/settings/")({
  component: SettingsPage,
});

function SettingsPage() {
  return (
    <>
      <PageHeader>
        <PageHeader.Content>
          <PageHeader.Title>Settings</PageHeader.Title>
          <PageHeader.Description>Manage your account settings and preferences.</PageHeader.Description>
        </PageHeader.Content>
      </PageHeader>
      <div className="p-6">
        <SettingsMenu />
      </div>
    </>
  );
}
